<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex" [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                    </div>
                </div>

                      <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">

            <div class="mat-toolbar-custom">
                <mat-toolbar>
                    <mat-toolbar-row>

                        <span class="mat-toolbar-row-separador"></span>

                        <button  *ngIf="!isInRole('CONSULTOR')"
                            (click)="dialogDeposito(1,null)" mat-flat-button
                            color="accent">{{Etiquetas.BotonADeposito}}</button>

                    </mat-toolbar-row>

                </mat-toolbar>

            </div>

        </div>
    </div>
</div>
<div class="container-custom-content">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                <mat-form-field color="accent-darker" appearance="standard">
                    <mat-label>{{Etiquetas.Buscar}}</mat-label>
                    <input matInput (keyup)="applyFilter($event)" #input>
                </mat-form-field>
                <div class="mat-table-depositos">
                    <table mat-table matTableResponsive [dataSource]="dataSource" matSort matSortActive="idPlanta"
                        matSortDirection="asc">

                        <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Headers.Acciones}} </th>
                            <td mat-cell *matCellDef="let d">
                                <div>

                                    <button matTooltip="{{Tooltips.Editar}}" (click)="dialogDeposito(2,d)"
                                        mat-icon-button color="primary-darker">
                                        <mat-icon color="accent-darker">edit</mat-icon>
                                    </button>

                                    <button matTooltip="{{Tooltips.Eliminar}}" (click)="eliminarDeposito(d)"
                                        mat-icon-button color="primary-darker">
                                        <mat-icon color="accent-darker">delete</mat-icon>
                                    </button>

                                </div>

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="idCompania">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.IdCompania}}
                            </th>
                            <td mat-cell *matCellDef="let d">
                                {{d.idCompania}} </td>
                        </ng-container>
                        <ng-container matColumnDef="idSalesOrg">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.IdSalesOrg}}
                            </th>
                            <td mat-cell *matCellDef="let d">
                                {{d.idSalesOrg}} </td>
                        </ng-container>

                        <ng-container matColumnDef="idPlanta">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.IdPlanta}}
                            </th>
                            <td mat-cell *matCellDef="let d">
                                {{d.idPlanta}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="descripcion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.Descripcion}}
                            </th>
                            <td mat-cell *matCellDef="let d">
                                {{d.descripcion}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cliente">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Headers.Cliente}}
                            </th>
                            <td mat-cell *matCellDef="let d">
                                <div>
                                    <mat-icon color="accent-darker">{{ d.cliente ?
                                        'check_box' :
                                        'check_box_outline_blank' }}
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>

                        

                        <ng-container matColumnDef="habilitacion">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Headers.Habilitacion}}
                            </th>
                            <td mat-cell *matCellDef="let d">
                                <div>
                                    <mat-icon color="accent-darker">{{ d.habilitacion ?
                                        'check_box' :
                                        'check_box_outline_blank' }}
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let d; columns: displayedColumns;">
                        </tr>


                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumns.length">{{Etiquetas.SinRegistros}}
                            </td>
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                    </mat-paginator>
                </div>

            </div>

        </div>

    </div>

</div>